(function ($) {

    let availableYears = [];

    /**
     * Constructor
     *
     * @param options
     * @constructor
     */
    function ChangeBusinessForSale(options) {
        console.log('ChangeBusinessForSale initialization');
        console.log(options);

        if (!options) {
            throw new Error('No options passed to ChangeBusinessForSale constructor');
        } else if (!options.yearsRange) {
            throw new Error('No option yearsRange passed to constructor');
        }

        this.options = $.extend({}, ChangeBusinessForSale.defaults, options);
        this.setup();
    }

    /**
     * Setup hooks
     */
    ChangeBusinessForSale.prototype.setup = function () {
        let self = this;
        let body = $('body');
        this.prepareYearsRange();
        this.restoreYearsDropdowns()

        $('#change-business-for-sale').on('submit', function (event) {
            event.preventDefault();
            if (!self.validate()) {
                return;
            }
            $('#message').hide().removeClass('alert-danger').removeClass('alert-success').empty()
            let fd = new FormData();
            fd.append('action', self.options.action);
            fd.append('businessID', $('#business-id').val());
            fd.append('firmName', $('#business-name').val());
            fd.append('listingTitle', $('#listing-title').val());
            fd.append('industry', $('#business-industry option:selected').val());
            fd.append('region', $('#business-region option:selected').val());
            fd.append('businessDescription', $('#business-description').val());

            if ($('#include-confidential-listing-on-linkedin').prop('checked') === true) {
                fd.append('includeConfidentialListingOnLinkedin', "on");
            }

            let fileObj = $('#form-file');
            if (fileObj.length) {
                fd.append('attachmentFile', fileObj.prop('files')[0]);
            }
            fd.append('attachmentTitle', $('#attachment-title').val());
            self.setFinancialDetails(fd);
            self.sendRequest(fd);
        });

        $('#add-more').on('click', function (event) {
            event.preventDefault();
            self.addFinancialDetailsBlock();
        });

        body.on('click', '.remove-financial-block a', function (event) {
            event.preventDefault();
            $(event.target).closest('.financial-detail').remove();
            self.prepareYearsRange();
            self.restoreYearsDropdowns()
        });

        body.on('click', '#file-attachment-upload', function (event) {
            event.preventDefault();
            $('#file-name-block').hide();
            $('#file-block').show();
            $('#form-file').prop('required', true);
        });

        body.on('input', '#listing-title', function (event) {
            event.preventDefault();
            self.checkTitleLength();
        });

        this.addNumberFields();
    }

    ChangeBusinessForSale.prototype.checkTitleLength = function () {
        console.log('change');
        let notice = $('#listing-title-length-notice');
        if ($('#listing-title').val().length >= 70) {
            notice.show();
        } else {
            notice.hide();
        }
    }

    ChangeBusinessForSale.prototype.validate = function () {
        let isValid = true;
        let businessNameField = $('#business-name');
        businessNameField.closest('.input-wrapper').find('.warning').remove();
        if (!businessNameField.val()) {
            businessNameField.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        let businessTitleField = $('#listing-title');
        businessTitleField.closest('.input-wrapper').find('.warning').remove();
        if (!businessTitleField.val()) {
            businessTitleField.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        let businessIndustry = $('#business-industry');
        businessIndustry.closest('.input-wrapper').find('.warning').remove();
        if (!businessIndustry.find('option:selected').val()) {
            businessIndustry.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        let businessRegion = $('#business-region');
        businessRegion.closest('.input-wrapper').find('.warning').remove();
        if (!businessRegion.find('option:selected').val()) {
            businessRegion.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        let businessDescription = $('#business-description');
        businessDescription.closest('.input-wrapper').find('.warning').remove();

        if (!businessDescription.val().replace(/(<([^>]+)>)/ig, "")) {
            businessDescription.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
            isValid = false;
        }

        let fdBlockInputs = $('#financial-block input.input-number');
        $.each(fdBlockInputs, function (key, value) {
            let inputElement = $(value);
            inputElement.closest('.input-wrapper').find('.warning').remove();
            if (!inputElement.val()) {
                inputElement.closest('.input-wrapper').append('<span class="warning" style="color: red">This field is required.</span>');
                isValid = false;
            } else if (inputElement.hasClass('revenue') && parseFloat(inputElement.val()) <= 0) {
                inputElement.closest('.input-wrapper').append('<span class="warning" style="color: red">Required revenue should be > 0</span>');
                isValid = false;
            }
        });

        return isValid;
    };

    ChangeBusinessForSale.prototype.addNumberFields = function () {
        new NumberInput({});
    }

    /**
     * Add new Financial Details block
     */
    ChangeBusinessForSale.prototype.addFinancialDetailsBlock = function () {
        console.log('Add block');
        let block = $('.financial-detail')
        block = block.clone();
        console.log(block);
        block.find('.fd-year').empty();
        block.find('.warning').remove();
        $.each(availableYears, function (key, value) {
            block.find('.fd-year').append('<option value="' + value + '">' + value + '</option>');
        });

        block.find('.remove-financial-block').show();
        $('#add-more').before(block[0].outerHTML);

        //Tooltip
        let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl, {
                'customClass': 'custom-tooltip'
            })
        })
        this.prepareYearsRange();
        this.restoreYearsDropdowns();

    }

    ChangeBusinessForSale.prototype.prepareYearsRange = function () {
        availableYears = JSON.parse(this.options.yearsRange);
        console.log(availableYears);
        let fd = $('.financial-detail');

        fd.each(function (fkey, fvalue) {
            let selectedYear = $(fvalue).find('.fd-year option:selected').val();

            for (let i = 0; i < availableYears.length; ++i) {
                //console.log(selectedYear);
                if (parseInt(selectedYear) === availableYears[i]) {
                    availableYears.splice(i, 1);
                }
            }
        });
    }

    /**
     * Add row between dates
     *
     * TODO: It not working. It deleting
     */
    ChangeBusinessForSale.prototype.restoreYearsDropdowns = function () {
        console.log(availableYears);

        let fd = $('.financial-detail');
        fd.each(function (fkey, fvalue) {
            let block = $(fvalue).find('.fd-year');
            let selectedYear = parseInt($(fvalue).find('.fd-year option:selected').val());
            let added = false;

            let options = $(this).find('option');
            options.each(function (optionKey, optionValue) {
                let optionVal = parseInt($(optionValue).val());
                let exist = false;
                for (let i = 0; i < availableYears.length; ++i) {
                    if (optionVal === availableYears[i] || selectedYear !== availableYears[i]) {
                        exist = true;
                    }
                }
                if (!exist) {
                    //console.log('NE' + optionVal);
                    //$(optionValue).remove();
                    //$(this).remove();
                    //console.log($(fd[fkey]));
                    //$(fd[fkey]).find('option[value="' + optionVal + '"]').remove();
                }
            });

            /*
                        for (let i = 0; i < availableYears.length; ++i) {
                            if (!added && i === 0 && selectedYear > availableYears.length[i]) {
                                block.append('<option value="' + selectedYear + '" selected>' + selectedYear + '</option>');
                                added = true;
                            } else if (!added && availableYears.length[i + 1] !== 'undefined' && availableYears.length[i + 1] > selectedYear > availableYears.length[i + 1]) {
                                block.append('<option value="' + selectedYear + '" selected>' + selectedYear + '</option>');
                                added = true;
                            } else if (!added && availableYears.length[i + 1] === 'undefined' && availableYears.length[i] > selectedYear) {
                                block.append('<option value="' + selectedYear + '" selected>' + selectedYear + '</option>');
                                added = true;
                            }
                        }

             */
            //block.append('<option value="' + availableYears[i] + '">' + availableYears[i] + '</option>');
        });
    }

    /**
     * Parse financial details blocks and add data to common object
     */
    ChangeBusinessForSale.prototype.setFinancialDetails = function (fd) {
        console.log('Set financial details');
        let finDetails = $('.financial-detail');
        let result = [];
        finDetails.each(function (key, value) {
            let financialData = {};
            let form = $(value);
            financialData.year = form.find('.fd-year option:selected').val();
            financialData.actualOrForecast = form.find('.fd-actual-forecast option:selected').val();
            financialData.revenue = form.find('.revenue').val();
            financialData.adjustedEBITDA = form.find('.adjusted-ebitda').val();
            result.push(financialData);
        });
        fd.append('financialDetails', JSON.stringify(result));
    }

    /**
     * Send AJAX request
     */
    ChangeBusinessForSale.prototype.sendRequest = function (fd) {
        let self = this;
        console.log('Send request');
        console.log(fd);

        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: fd,
            processData: false,
            contentType: false,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
                self.disableInputs();
            },
            success: function (response) {
                self.parseResponse(response);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    /**
     * Disable all elements on page
     */
    ChangeBusinessForSale.prototype.disableInputs = function () {
        let form = $('#change-business-for-sale');
        form.find('input').prop("disabled", true);
        form.find('select').prop("disabled", true);
        form.find('textarea').prop("disabled", true);
        $('#add-more').hide();
        $('#spinner').show();
    }

    /**
     * Enable all elements on page
     */
    ChangeBusinessForSale.prototype.enableInputs = function () {
        let form = $('#change-business-for-sale');
        form.find('input').prop("disabled", false);
        form.find('select').prop("disabled", false);
        form.find('textarea').prop("disabled", false);
        $('#add-more').show();
        $('#spinner').hide();
    }

    /**
     * Parse response
     *
     * @param response
     */
    ChangeBusinessForSale.prototype.parseResponse = function (response) {
        let self = this;
        let message = $('#message');
        console.log(response);
        if (response.status !== 'success') {
            self.enableInputs();
            message.append(response.message).addClass('alert-danger').show();
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.dashboard-heading').offset().top - 60
            }, 500);
            return;
        }

        if (response.redirect_URL !== 'undefined' && response.redirect_URL) {
            window.location.href = response.redirect_URL;
        } else {
            message.append(response.message).addClass('alert-success').show();
            $('#change-business-for-sale').hide();
        }
    }

    ChangeBusinessForSale.defaults = {};
    window.ChangeBusinessForSale = ChangeBusinessForSale;

})(jQuery);